import { Pipe } from '@angular/core';
var IsArrayPipe = (function () {
    function IsArrayPipe() {
    }
    IsArrayPipe.prototype.transform = function (input) {
        return Array.isArray(input);
    };
    IsArrayPipe.decorators = [
        { type: Pipe, args: [{ name: 'isArray' },] },
    ];
    /** @nocollapse */
    IsArrayPipe.ctorParameters = function () { return []; };
    return IsArrayPipe;
}());
export { IsArrayPipe };
//# sourceMappingURL=is-array.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/boolean/is-array.js
// module id = 240
// module chunks = 4